import { t } from '@lingui/core/macro';
import { cn } from 'noddi-ui-common';
import { NoddiSkeleton } from 'noddi-ui-web';

type Props = {
  /** One placeholder per card the step usually lands with. */
  rows?: number;
  /** Height of each placeholder, close to the loaded card so the page does not jump. */
  rowClassName?: string;
  className?: string;
};

/**
 * Loading body for a booking step: card-shaped placeholders under the step's own title and progress,
 * in place of a page-high spinner, so every step loads the same way.
 */
export const BookingStepSkeleton = ({ rows = 3, rowClassName = 'h-24', className }: Props) => (
  <div role='status' className={cn('flex flex-col gap-4', className)}>
    <span className='sr-only'>{t`Loading`}</span>
    {Array.from({ length: rows }, (_, index) => (
      <NoddiSkeleton key={index} className={cn('w-full rounded-xl', rowClassName)} />
    ))}
  </div>
);
